module.exports = __webpack_public_path__ + "img/banner1.7994d4e8.jpg";